import { Button } from '@mui/material';
import { useBulkUploadPoiActions } from '../actions';
import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';
import { useBulkUploadPoisMutation } from '@/__generated__/graphql';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import * as state from '@/components/Analysis/state';
import { useSetAtom } from 'jotai';
import { csvStringToJson } from '@/components/Analysis/Idms/utils';

export const ConfirmationDialog = () => {
  const setApplyFilters = useSetAtom(state.applyFilters);
  const { getGetBulkModalState, closeAllModals, getUploadInput } = useBulkUploadPoiActions();
  const modalState = getGetBulkModalState();

  const [bulkUploadPois, { loading }] = useBulkUploadPoisMutation();

  const { showSnackBar } = useSnackBarMessage({});

  const isOpen = modalState === 'confirm';

  if (!isOpen) return <></>;

  const input = getUploadInput();

  const onClose = () => {
    closeAllModals();
  };

  const onConfirm = () => {
    if (!input) {
      showSnackBar('Could not create upload input. Please contact support', 'error');
      return;
    }

    bulkUploadPois({
      variables: {
        input,
      },
    })
      .then(() => {
        // Janky way to get the POI table to re-render
        // and refetch the POIs, to refresh the POI table after an upload is complete
        setApplyFilters(true);
        showSnackBar('Uploaded successfully', 'success');
        showSnackBar('Points of interest uploaded successfully', 'success');
        onClose();
      })
      .catch(() => {
        showSnackBar('Could not upload points of interest. Please contact support', 'error');
      });
  };

  const { rows } = csvStringToJson(input?.csv as string);
  const numberOfPois = rows?.length || 0;

  return (
    <GenericConfirmationDialog
      title="Adding points of interest"
      description={`File validation completed. Please confirm to update the data by adding '${numberOfPois}' points of interest to Abyss fabric.`}
      open={isOpen}
      onClose={onClose}
    >
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} disabled={loading} variant="contained">
        Confirm
      </Button>
    </GenericConfirmationDialog>
  );
};
